// rename this file to firebase.js and fill in the correct values

import firebase from 'firebase'
const config = {
    apiKey: "AIzaSyDUsFXHnsd9eGerEMgXFzSsqRZreOpTV68",
    authDomain: "intrapologygamejam.firebaseapp.com",
    databaseURL: "https://intrapologygamejam-default-rtdb.firebaseio.com/",
    projectId: "intrapologygamejam",
    storageBucket: "intrapologygamejam.appspot.com",
    messagingSenderId: "207542571168"
};
firebase.initializeApp(config);
export default firebase;
